import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByPlatform',
    standalone: false
})
export class FilterByPlatformPipe implements PipeTransform {
  transform(items: any[], platform: string): any[] {
    if (!items || !platform) {
      return items;
    }
    return items.filter(item => item.PlatformName === platform);
  }
}